/* src/app/modules/accounting/accounting-accounts/accounting-accounts.component.css */
.container-fluid p,
.container-fluid span,
.container-fluid button {
  font-size: 15px;
}
.table td,
.table th {
  padding: 3px;
  font-size: 15px;
}
.container-fluid p {
  margin-bottom: 5px;
}
.container-fluid p span {
  font-weight: 700;
}
.hover-ledger:hover {
  background-color: #e3fd64;
}
/*# sourceMappingURL=accounting-accounts.component.css.map */
